import { object } from "@/common/object.util";
import ApiAdmin from "@/services/apiAdmin.service";

import {
  FETCH_ALL,
  FETCH,
  FETCH_ORGANIZATION_PARAMS,
  FETCH_ALL_ORGANIZATION_FORNECEDORAS,
  FETCH_ALL_ORGANIZATION_CLIENTES,
  SAVE,
  DELETE,
  CLEAR_ALL
} from "@/store/actions/actions.type";

import {
  FETCH_ALL_START,
  SET_ALL,
  FETCH_ALL_END,
  UNSET_ALL,
  FETCH_START,
  SET,
  SET_ORGANIZATIONS_FORNECEDORAS,
  SET_ORGANIZATIONS_CLIENTES,
  SET_ORGANIZATION,
  FETCH_END,
  DELETE_START,
  UNSET,
  DELETE_END,
  SAVE_START,
  SAVE_END
} from "@/store/mutations/mutations.type";

const defaults = Object.freeze({
  organization: {
    id: null,
    ativo_para_cobranca: null,
    nome_comercial: "",
    group_id_token: "",
    is_cliente: false,
    is_fornecedor: false,
    block_acessos_fora_do_plano: false,
    organization_fornecedor_info: {
      porcentagem_royalties: null,
      gael_fornecedor_id: 0
    },
    platforms: [],
    organization_params: {
      ver_plano_ensino: 0,
      ver_questoes: 0
    },
    billing: {
      id: undefined,
      fee_mensal_fixo: 0,
      organization_id: undefined,
      data_inicio_contrato: null,
      melhor_dia_de_compra: null,
      has_asaas_account: false,
      asaas_account_id: null,
      asaas_customer_id: null,
      asaas_wallet_split_id: null,
      asaas_api_key: null,
      email: null,
      emails_adicionais: "",
      emailsAdicionaisRawArray: [],
      cnpj: null,
      telefone: null,
      CEP: null,
      endereco: null,
      numero: null,
      bairro: null
      // complemento: null
    },
    alice_api_auth_infos: {
      iss: "",
      api_key: "",
      secret_key: ""
    },
    acervos: []
  },
  organizations: {
    current_page: 1,
    per_page: 10,
    data: [],
    total: undefined,
    filters: []
  },
  organizationsFornecedoras: {
    id: null
  },
  organizationsFornecedoras: {
    data: []
  },
  organizationsClientes: {
    data: []
  }
});

const state = {
  organizations: object.clone(defaults.organizations),
  organization: object.clone(defaults.organization),
  organizationOriginal: object.clone(defaults.organization),
  organizationsFornecedoras: object.clone(defaults.organizationsFornecedoras),
  organizationsClientes: object.clone(defaults.organizationsClientes),
  isFetchingOrganizations: false,
  isFetchingOrganization: false,
  isSavingOrganization: false,
  isDeletingOrganization: false,
  deletingId: null
};
const getters = {
  organization(state) {
    return state.organization;
  },
  organizations(state) {
    return state.organizations;
  },
  organizationsClientes(state) {
    return state.organizationsClientes;
  },
  organizationsFornecedoras(state) {
    return state.organizationsFornecedoras;
  },
  isFetchingOrganizations(state) {
    return state.isFetchingOrganizations;
  },
  isFetchingOrganization(state) {
    return state.isFetchingOrganization;
  },
  isSavingOrganization(state) {
    return state.isSavingOrganization;
  },
  isDeletingOrganization(state) {
    return state.isDeletingOrganization;
  },
  deletingId(state) {
    return state.deletingId;
  }
};

const actions = {
  [FETCH_ALL_ORGANIZATION_CLIENTES](context, params) {
    return new Promise((resolve, reject) => {
      ApiAdmin.query("organizations/clientes/list", params)
        .then(response => {
          context.commit(SET_ORGANIZATIONS_CLIENTES, response.data);
          resolve();
        })
        .catch(e => {
          reject(e.response.data);
        });
    });
  },
  [FETCH_ALL_ORGANIZATION_FORNECEDORAS](context, params) {
    return new Promise((resolve, reject) => {
      ApiAdmin.query("organizations/fornecedores/list", params)
        .then(response => {
          context.commit(SET_ORGANIZATIONS_FORNECEDORAS, response.data);
          resolve(response.data);
        })
        .catch(e => {
          reject(e.response.data);
        });
    });
  },
  [FETCH_ALL](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_ALL_START);

      ApiAdmin.query("organizations/list/frontend", params)
        .then(response => {
          context.commit(SET_ALL, response.data);
          resolve();
        })
        .catch(e => {
          reject(e.response.data);
        })
        .finally(() => {
          context.commit(FETCH_ALL_END);
        });
    });
  },
  [FETCH](context, organizationId) {
    return new Promise((resolve, reject) => {
      context.commit(SET, object.clone(defaults.organization));

      if (!organizationId) {
        resolve();
        return;
      }

      context.commit(FETCH_START);

      ApiAdmin.get("organizations/get", organizationId)
        .then(response => {
          if (response.data.id) {
            context.commit(SET, response.data);
            resolve(response);
          } else {
            reject({ notFound: true });
          }
        })
        .catch(e => {
          reject(e);
        })
        .finally(() => {
          context.commit(FETCH_END);
        });
    });
  },
  [FETCH_ORGANIZATION_PARAMS](context) {
    return new Promise((resolve, reject) => {
      ApiAdmin.get(`organizations/params/get`)
        .then(response => {
          context.commit(SET_ORGANIZATION, response.data);
          resolve(response);
        })
        .catch(e => {
          console.log(e);
          reject(e.response);
        })
        .finally(() => {});
    });
  },
  [SAVE](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(SAVE_START);

      if (params.id) {
        ApiAdmin.put("organizations/update", params.id, params)
          .then(response => {
            context.commit(SET, response.data.organization);
            resolve();
          })
          .catch(e => {
            reject(e);
          })
          .finally(() => {
            context.commit(SAVE_END);
          });
      } else {
        ApiAdmin.post("organizations/create", params)
          .then(response => {
            context.commit(SET, response.data.organization);
            resolve();
          })
          .catch(e => {
            reject(e.response);
          })
          .finally(() => {
            context.commit(SAVE_END);
          });
      }
    });
  },
  [DELETE](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(DELETE_START, params);

      ApiGael.delete("cursos/delete", params)
        .then(() => {
          context.commit(UNSET, params);
          resolve();
        })
        .catch(e => {
          reject(e.response);
        })
        .finally(() => {
          context.commit(DELETE_END);
        });
    });
  },
  [CLEAR_ALL](context) {
    return new Promise(resolve => {
      context.commit(UNSET_ALL);
      resolve();
    });
  }
};

const mutations = {
  [FETCH_ALL_START](state) {
    state.isFetchingOrganizations = true;
  },
  [SET_ALL](state, organizations) {
    state.organizations = organizations;
  },
  [FETCH_ALL_END](state) {
    state.isFetchingOrganizations = false;
  },
  [UNSET_ALL](state) {
    state.organizations = object.clone(defaults.organizations);
  },
  [SET_ORGANIZATION](state, organization) {
    state.organization = organization;
  },
  [FETCH_START](state) {
    state.isFetchingOrganization = true;
  },
  [SET](state, organization) {
    state.organization = organization;
    state.organizationOriginal = object.clone(organization);
  },
  [SET_ORGANIZATIONS_FORNECEDORAS](state, organizationsFornecedoras) {
    state.organizationsFornecedoras = organizationsFornecedoras;
  },
  [SET_ORGANIZATIONS_CLIENTES](state, organizationsClientes) {
    state.organizationsClientes = organizationsClientes;
  },
  [FETCH_END](state) {
    state.isFetchingOrganization = false;
  },
  [DELETE_START](state, organizationId) {
    state.deletingId = organizationId;
    state.isDeletingOrganization = true;
  },
  [UNSET](state, id) {
    state.organizations.data = state.organizations.data.filter(item => {
      return item.id != id;
    });
  },
  [DELETE_END](state) {
    state.isDeletingOrganization = false;
    state.deletingId = null;
  },
  [SAVE_START](state) {
    state.isSavingOrganization = true;
  },
  [SAVE_END](state) {
    state.isSavingOrganization = false;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
